<template>
  <can I="create" a="users">
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12">
            <b-card>
              <div slot="header">{{ $t('user_create_title') }}</div>
              <div v-if="spinners.contentIsLoading" class="text-center">
                <b-spinner type="grow" variant="primary"/>
              </div>
              <div v-else>
                <b-row>
                  <b-col cols="12" md="4">
                    <b-form-group>
                      <label>{{ $t('name') }}</label>
                      <b-form-input type="text" :placeholder=" 'name_placeholder' | translate('global') "
                                    :class="{ 'is-invalid' : errorMsg.name }"
                                    v-model="user.name"/>
                      <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
                    </b-form-group>

                    <b-form-group>
                      <label>{{ $t('email') }}</label>
                      <b-form-input type="text" :placeholder=" 'email_placeholder' | translate('global') "
                                    :class="{ 'is-invalid' : errorMsg.email }"
                                    v-model="user.email"/>
                      <div class="invalid-feedback" v-if="errorMsg.email">{{ errorMsg.email[0] }}</div>
                    </b-form-group>

                    <b-form-group>
                      <label>{{ $t('password') }}</label>
                      <b-form-input type="password"
                                    :placeholder=" 'password_placeholder' | translate('global') "
                                    :class="{ 'is-invalid' : errorMsg.password }"
                                    v-model="user.password"/>
                      <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                    </b-form-group>

                    <b-form-group>
                      <label>{{ $t('password_repeat') }}</label>
                      <b-form-input type="password"
                                    :placeholder=" 'password_repeat_placeholder' | translate('global') "
                                    :class="{ 'is-invalid' : errorMsg.password }"
                                    v-model="user.password_confirmation"/>
                      <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="8">
                    <b-form-group>
                      <label>{{ $t('roles') }}</label>
                      <treeselect :class="{ 'treeselect-error' : errorMsg.roles }"
                                  :placeholder=" 'roles_placeholder' | translate('global') "
                                  :multiple="true" :options="roleOptions" v-model="user.roles"
                      />
                      <span class="error-text" v-if="errorMsg.roles">{{ errorMsg.roles[0] }}</span>
                    </b-form-group>
                    <b-form-checkbox id="is_active" v-model="user.is_active" :value="true">
                      {{ $t('active') }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </div>

              <div slot="footer">
                <b-button type="submit" variant="success" @click="onSave()">
                  <b-spinner v-if="spinners.isSaving" type="grow" small/>
                  {{ $t('save') }}
                </b-button>
                <b-button :to="{ name: 'ApplyUsers' }" type="reset" variant="danger" class="ml-2">
                  {{ $t('cancel') }}
                </b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </can>
</template>

<script>
import statuses from '@/store/statuses';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import forEach from 'lodash.foreach';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';

const UsersTypes = VuexTypes.users;
export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      user: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        is_active: true,
        roles: []
      },
      roleOptions: [],
      errorMsg: {}
    };
  },
  components: { Treeselect },
  computed: {
    ...mapGetters('Users', [
      'userCreateData',
      'userCreate',
    ]),
  },
  watch: {
    userCreateData: {
      handler: function () {
        if (this.userCreateData.status === statuses.LOADED) {
          this.spinners.contentIsLoading = false;
          const roles = [];
          forEach(this.userCreateData.data.roles, (role) => {
            roles.push({
              id: role['id'],
              label: this.$t(role['name'], 'global')
            });
          });
          this.roleOptions = roles;
        }
      },
      deep: true
    },
    userCreate: {
      handler: function () {
        this.errorMsg = {};
        this.spinners.isSaving = false;
        if (this.userCreate.status === statuses.LOADED) {
          this.alertSuccess();
          this.$router.push({ name: 'UserUpdate', params: { id: this.userCreate.data.id } });
        } else if (this.userCreate.status === statuses.ERROR) {
          this.alertError();
          this.errorMsg = this.userCreate.data.data.errors;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Users', [
      UsersTypes.USER_CREATE_DATA,
      UsersTypes.USER_CREATE
    ]),
    getData() {
      this.USER_CREATE_DATA();
    },
    onSave() {
      this.spinners.isSaving = true;
      this.USER_CREATE(this.user);
    }
  }
};
</script>

<style scoped>
</style>
